// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { IndustryOut } from './industryOut.zod.ts';

export const industryRejectOutAssetsRetaggedDefault = 0;
export const industryRejectOutCasesRetaggedDefault = 0;

export const IndustryRejectOut = zod.object({
  "assets_retagged": zod.int().default(industryRejectOutAssetsRetaggedDefault),
  "cases_retagged": zod.int().default(industryRejectOutCasesRetaggedDefault),
  "ideas_reassigned": zod.int(),
  "replacement": zod.union([IndustryOut,zod.null()])
});

export type IndustryRejectOut = zod.input<typeof IndustryRejectOut>;
export type IndustryRejectOutOutput = zod.output<typeof IndustryRejectOut>;
